import type GameVersion from './GameVersion'

export const characterClasses = [
  'Death Knight',
  'Demon Hunter',
  'Druid',
  'Evoker',
  'Hunter',
  'Mage',
  'Monk',
  'Paladin',
  'Priest',
  'Rogue',
  'Shaman',
  'Warlock',
  'Warrior',
] as const

export const classColours: Record<
  CharacterClass,
  { active: string; hover: string; text: string; activeText: string }
> = {
  'Death Knight': {
    active:
      'bg-gradient-to-b from-class-death-knight/62 via-class-death-knight/78 to-class-death-knight/66 shadow-[inset_0_1px_0_rgba(255,255,255,0.12),inset_0_-1px_0_rgba(0,0,0,0.16)]',
    hover:
      'hover:bg-gradient-to-b hover:from-class-death-knight/18 hover:via-class-death-knight/30 hover:to-class-death-knight/24',
    text: 'dark:text-class-death-knight',
    activeText: 'text-zinc-50',
  },
  'Demon Hunter': {
    active:
      'bg-gradient-to-b from-class-demon-hunter/62 via-class-demon-hunter/78 to-class-demon-hunter/66 shadow-[inset_0_1px_0_rgba(255,255,255,0.12),inset_0_-1px_0_rgba(0,0,0,0.16)]',
    hover:
      'hover:bg-gradient-to-b hover:from-class-demon-hunter/18 hover:via-class-demon-hunter/30 hover:to-class-demon-hunter/24',
    text: 'dark:text-class-demon-hunter',
    activeText: 'text-zinc-50',
  },
  Druid: {
    active:
      'bg-gradient-to-b from-class-druid/62 via-class-druid/78 to-class-druid/66 shadow-[inset_0_1px_0_rgba(255,255,255,0.12),inset_0_-1px_0_rgba(0,0,0,0.16)]',
    hover:
      'hover:bg-gradient-to-b hover:from-class-druid/18 hover:via-class-druid/30 hover:to-class-druid/24',
    text: 'dark:text-class-druid',
    activeText: 'text-zinc-950',
  },
  Evoker: {
    active:
      'bg-gradient-to-b from-class-evoker/62 via-class-evoker/78 to-class-evoker/66 shadow-[inset_0_1px_0_rgba(255,255,255,0.12),inset_0_-1px_0_rgba(0,0,0,0.16)]',
    hover:
      'hover:bg-gradient-to-b hover:from-class-evoker/18 hover:via-class-evoker/30 hover:to-class-evoker/24',
    text: 'dark:text-class-evoker',
    activeText: 'text-zinc-950',
  },
  Hunter: {
    active:
      'bg-gradient-to-b from-class-hunter/62 via-class-hunter/78 to-class-hunter/66 shadow-[inset_0_1px_0_rgba(255,255,255,0.12),inset_0_-1px_0_rgba(0,0,0,0.16)]',
    hover:
      'hover:bg-gradient-to-b hover:from-class-hunter/18 hover:via-class-hunter/30 hover:to-class-hunter/24',
    text: 'dark:text-class-hunter',
    activeText: 'text-zinc-950',
  },
  Mage: {
    active:
      'bg-gradient-to-b from-class-mage/62 via-class-mage/78 to-class-mage/66 shadow-[inset_0_1px_0_rgba(255,255,255,0.12),inset_0_-1px_0_rgba(0,0,0,0.16)]',
    hover:
      'hover:bg-gradient-to-b hover:from-class-mage/18 hover:via-class-mage/30 hover:to-class-mage/24',
    text: 'dark:text-class-mage',
    activeText: 'text-zinc-950',
  },
  Monk: {
    active:
      'bg-gradient-to-b from-class-monk/62 via-class-monk/78 to-class-monk/66 shadow-[inset_0_1px_0_rgba(255,255,255,0.12),inset_0_-1px_0_rgba(0,0,0,0.16)]',
    hover:
      'hover:bg-gradient-to-b hover:from-class-monk/18 hover:via-class-monk/30 hover:to-class-monk/24',
    text: 'dark:text-class-monk',
    activeText: 'text-zinc-950',
  },
  Paladin: {
    active:
      'bg-gradient-to-b from-class-paladin/62 via-class-paladin/78 to-class-paladin/66 shadow-[inset_0_1px_0_rgba(255,255,255,0.12),inset_0_-1px_0_rgba(0,0,0,0.16)]',
    hover:
      'hover:bg-gradient-to-b hover:from-class-paladin/18 hover:via-class-paladin/30 hover:to-class-paladin/24',
    text: 'dark:text-class-paladin',
    activeText: 'text-zinc-950',
  },
  Priest: {
    active:
      'bg-gradient-to-b from-class-priest/62 via-class-priest/78 to-class-priest/66 shadow-[inset_0_1px_0_rgba(255,255,255,0.12),inset_0_-1px_0_rgba(0,0,0,0.16)]',
    hover:
      'hover:bg-gradient-to-b hover:from-class-priest/18 hover:via-class-priest/30 hover:to-class-priest/24',
    text: 'dark:text-class-priest',
    activeText: 'text-zinc-950',
  },
  Rogue: {
    active:
      'bg-gradient-to-b from-class-rogue/62 via-class-rogue/78 to-class-rogue/66 shadow-[inset_0_1px_0_rgba(255,255,255,0.12),inset_0_-1px_0_rgba(0,0,0,0.16)]',
    hover:
      'hover:bg-gradient-to-b hover:from-class-rogue/18 hover:via-class-rogue/30 hover:to-class-rogue/24',
    text: 'dark:text-class-rogue',
    activeText: 'text-zinc-950',
  },
  Shaman: {
    active:
      'bg-gradient-to-b from-class-shaman/62 via-class-shaman/78 to-class-shaman/66 shadow-[inset_0_1px_0_rgba(255,255,255,0.12),inset_0_-1px_0_rgba(0,0,0,0.16)]',
    hover:
      'hover:bg-gradient-to-b hover:from-class-shaman/18 hover:via-class-shaman/30 hover:to-class-shaman/24',
    text: 'dark:text-class-shaman',
    activeText: 'text-zinc-50',
  },
  Warlock: {
    active:
      'bg-gradient-to-b from-class-warlock/62 via-class-warlock/78 to-class-warlock/66 shadow-[inset_0_1px_0_rgba(255,255,255,0.12),inset_0_-1px_0_rgba(0,0,0,0.16)]',
    hover:
      'hover:bg-gradient-to-b hover:from-class-warlock/18 hover:via-class-warlock/30 hover:to-class-warlock/24',
    text: 'dark:text-class-warlock',
    activeText: 'text-zinc-50',
  },
  Warrior: {
    active:
      'bg-gradient-to-b from-class-warrior/62 via-class-warrior/78 to-class-warrior/66 shadow-[inset_0_1px_0_rgba(255,255,255,0.12),inset_0_-1px_0_rgba(0,0,0,0.16)]',
    hover:
      'hover:bg-gradient-to-b hover:from-class-warrior/18 hover:via-class-warrior/30 hover:to-class-warrior/24',
    text: 'dark:text-class-warrior',
    activeText: 'text-zinc-950',
  },
}

type CharacterClass = typeof characterClasses[number]
export default CharacterClass

export type { GameVersion }

const vanillaClasses: CharacterClass[] = [
  'Druid',
  'Hunter',
  'Mage',
  'Paladin',
  'Priest',
  'Rogue',
  'Shaman',
  'Warlock',
  'Warrior',
]

export const characterClassesByGameVersion: Record<
  GameVersion,
  CharacterClass[]
> = {
  live: [...characterClasses],
  classic_progression: [
    'Death Knight',
    'Druid',
    'Hunter',
    'Mage',
    'Monk',
    'Paladin',
    'Priest',
    'Rogue',
    'Shaman',
    'Warlock',
    'Warrior',
  ],
  classic_era: vanillaClasses,
  classic_forever: vanillaClasses,
  classic_anniversary: [
    'Druid',
    'Hunter',
    'Mage',
    'Paladin',
    'Priest',
    'Rogue',
    'Shaman',
    'Warlock',
    'Warrior',
  ],
}
